import {
    FETCH_HCPCS_REQUEST, FETCH_HCPCS_SUCCESS, FETCH_HCPCS_FAILURE,
    CREATE_HCPC_SUCCESS, UPDATE_HCPC_SUCCESS, DELETE_HCPC_SUCCESS,
    FETCH_HCPC_RULES_SUCCESS
  } from '../actions/hcpcActions';
  
  const initialState = {
    hcpcs: [],
    rules: [],
    loading: false,
    error: null,
  };
  
  export default function hcpcReducer(state = initialState, action) {
    switch (action.type) {
      case FETCH_HCPCS_REQUEST:
        return { ...state, loading: true };
      case FETCH_HCPCS_SUCCESS:
        return { ...state, loading: false, hcpcs: action.payload };
      case FETCH_HCPCS_FAILURE:
        return { ...state, loading: false, error: action.payload };
      case CREATE_HCPC_SUCCESS:
        return { ...state, hcpcs: [...state.hcpcs, action.payload] };
      case UPDATE_HCPC_SUCCESS:
        return {
          ...state,
          hcpcs: state.hcpcs.map((hcpc) => (hcpc.id === action.payload.id ? action.payload : hcpc)),
        };
      case DELETE_HCPC_SUCCESS:
        return { ...state, hcpcs: state.hcpcs.filter((hcpc) => hcpc.id !== action.payload) };
      case FETCH_HCPC_RULES_SUCCESS:
        return { ...state, rules: action.payload };
      default:
        return state;
    }
  }
  